import React, { useState } from 'react';
import { PanelHeader } from 'js/components';
import {
  Button,
  Card,
  CardBody,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
} from 'reactstrap';

function AccountsSettingsComponent({ account, _me, onSubmit }) {
  const [name, setName] = useState(account.name);
  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(name);
  };

  const handleChange = (e) => {
    setName(e.target.value);
  };
  return (
    <div>
      <PanelHeader size="flex" />
      <div className="content">
        <Card>
          <CardBody>
            <Form onSubmit={handleSubmit}>
              <Row>
                <Col sm={4}>
                  <Label for="account_name">Account Name</Label>
                  <FormGroup>
                    <Input
                      onChange={handleChange}
                      value={name}
                      id="account_name"
                      type="text"
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Button
                    color="primary"
                    type="submit"
                    value="submit"
                    disabled={
                      name === account.name || name === '' || name.trim() === ''
                    }
                    className="float-left btn btn-primary"
                    data-test="account-settings-submit"
                  >
                    Save
                  </Button>
                </Col>
              </Row>
            </Form>
          </CardBody>
        </Card>
      </div>
    </div>
  );
}

export default AccountsSettingsComponent;
